import { getCsrfToken } from "../form_helpers";

/**
 * Fetch a single device by ID using the GET /api/items/:id endpoint
 * @param {string} id - The device ID to fetch
 * @returns {Promise<Object>} - Promise that resolves to the device object
 */
export async function getDevice(id) {
    if (!id) {
        throw new Error('Device ID is required');
    }

    try {
        // Build the URL for the single-item GET request
        const url = new URL(`/api/items/${encodeURIComponent(id)}`, window.location.origin);

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': getCsrfToken()
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch device: ${ response.status } ${ response.statusText }`);
        }

        const responseData = await response.json();

        // The endpoint returns { status: 'success', data: { ...flat item... } }
        if (responseData.data) {
            return responseData.data;
        } else {
            throw new Error('Device not found');
        }

    } catch (error) {
        console.error('Error fetching device:', error);
        throw error;
    }
}